export default __webpack_public_path__ + "static/media/arrow-next.d7cfb44b.svg";